/**
 * Typed CustomEvent helpers for widget events.
 *
 * Events bubble out of the Shadow DOM via `composed: true` so the host site
 * can listen on the Custom Element directly:
 *
 *   document.querySelector('propelsia-booking')
 *     .addEventListener('propelsia:booking:completed', (e) => …)
 */

export type WidgetEventDetail = Record<string, unknown>;

export interface DispatchOptions {
  bubbles?: boolean;
  composed?: boolean;
  cancelable?: boolean;
}

export function dispatchWidgetEvent<TDetail extends WidgetEventDetail>(
  target: EventTarget,
  eventName: string,
  detail: TDetail,
  options: DispatchOptions = {},
): boolean {
  const event = new CustomEvent<TDetail>(eventName, {
    detail,
    bubbles: options.bubbles ?? true,
    composed: options.composed ?? true,
    cancelable: options.cancelable ?? false,
  });
  return target.dispatchEvent(event);
}
